import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';

const getColorForDifficulty = (difficulty) => {
  if (difficulty >= 0 && difficulty <= 25) return '#90ee90'; // Light green
  if (difficulty >= 26 && difficulty <= 35) return '#4caf50'; // Green
  if (difficulty >= 36 && difficulty <= 45) return '#ffeb3b'; // Yellow
  if (difficulty >= 46 && difficulty <= 60) return '#ff9800'; // Orange
  if (difficulty >= 61 && difficulty <= 75) return '#f57c00'; // Reddish orange
  return '#f44336'; // Red
};

const KeywordDifficultyChart = ({ difficulty }) => {
  const svgRef = useRef(null);

  useEffect(() => {
    const width = 110;
    const height = 110;
    const radius = Math.min(width, height) / 2;
    const strokeWidth = 20;
    const backgroundColor = '#e6e6e6';

    // Determine the color based on the difficulty
    const color = getColorForDifficulty(difficulty);

    const svg = d3.select(svgRef.current)
      .attr('width', width)
      .attr('height', height)
      .attr('viewBox', `0 0 ${width} ${height}`)
      .append('g')
      .attr('transform', `translate(${width / 2}, ${height / 2})`);

    const arc = d3.arc()
      .innerRadius(radius - strokeWidth)
      .outerRadius(radius)
      .startAngle(0);

    // Background circle
    svg.append('path')
      .attr('d', arc.endAngle(2 * Math.PI))
      .attr('fill', backgroundColor);

    // Foreground circle (representing difficulty)
    svg.append('path')
      .attr('d', arc.endAngle((2 * Math.PI) * (difficulty / 100)))
      .attr('fill', color);

    // Text in the center
    svg.append('text')
      .attr('y', 0)
      .attr('x', 0)
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'middle')
      .attr('font-size', '18px')
      .text(`${difficulty}%`)
      .style('font-family', 'Quicksand');

    return () => {
      d3.select(svgRef.current).selectAll('*').remove();
    };
  }, [difficulty]);

  return <svg ref={svgRef} />;
};

export default KeywordDifficultyChart;
